import api from "./Api";

class IntegracaoMercadoLivreService {
  GetAuthorizationUrl() {
    return api
      .get("/v1/integracoes/mercadolivre/authorization-url")
      .then((response) => {
        return response.data;
      });
  }

  ExchangeCode(payload) {
    return api
      .post("/v1/integracoes/mercadolivre/exchange-code", payload)
      .then((response) => {
        return response.data;
      });
  }

  SearchCategories(query) {
    return api
      .get("/v1/integracoes/mercadolivre/categories/search", {
        params: { query },
      })
      .then((response) => {
        return response.data;
      });
  }

  GetPresetByCategory(categoryId) {
    return api
      .get(`/v1/integracoes/mercadolivre/presets/category/${categoryId}`)
      .then((response) => {
        return response.data;
      });
  }

  GetGridSchema(categoryId, payload) {
    return api
      .post(
        `/v1/integracoes/mercadolivre/presets/category/${categoryId}/grid-schema`,
        payload
      )
      .then((response) => {
        return response.data;
      });
  }

  ExportProducts(payload) {
    return api
      .post("/v1/integracoes/mercadolivre/produtos/exportar", payload)
      .then((response) => {
        return response.data;
      });
  }

  ImportProducts() {
    return api
      .post("/v1/integracoes/mercadolivre/produtos/importar")
      .then((response) => {
        return response.data;
      });
  }

  ImportOrders(payload) {
    return api
      .post("/v1/integracoes/mercadolivre/pedidos/importar", payload)
      .then((response) => {
        return response.data;
      });
  }

  RefreshToken() {
    return api
      .post("/v1/integracoes/mercadolivre/refresh-token")
      .then((response) => {
        return response.data;
      });
  }

  Disconnect() {
    return api
      .post("/v1/integracoes/mercadolivre/disconnect")
      .then((response) => {
        return response.data;
      });
  }
}

export default new IntegracaoMercadoLivreService();
